export const getLocalStorageItem = <T>(key: string): T | null => {
  const localStorageValue = localStorage.getItem(key)
  if (typeof localStorage === 'undefined' || !localStorageValue) {
    return null
  }

  return JSON.parse(localStorageValue || '')
}

export const COOKIE_BANNER_KEY = 'cookieBannerShowed'
